var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var AsyncIterator = require('asynciterator'); // merges the contents of multiple streams


var MergeIterator =
/*#__PURE__*/
function (_AsyncIterator) {
  "use strict";

  _inherits(MergeIterator, _AsyncIterator);

  function MergeIterator(streams) {
    var _this;

    _classCallCheck(this, MergeIterator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MergeIterator).call(this));
    if (!Array.isArray(streams)) streams = Array.prototype.slice.call(arguments);
    _this.streams = streams;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      var _loop = function _loop() {
        var stream = _step.value;
        stream.on('readable', function () {
          return _this.emit('readable');
        });
        stream.on('end', function () {
          return _this._removeStream(stream);
        });
      };

      for (var _iterator = streams[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        _loop();
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    if (_this.streams.length === 0) _this.close();
    _this.idx = _this.streams.length - 1;
    return _this;
  }

  _createClass(MergeIterator, [{
    key: "_removeStream",
    value: function _removeStream(stream) {
      var idx = this.streams.indexOf(stream);
      if (idx < 0) return;
      this.streams.splice(idx, 1);
      if (this.idx >= this.streams.length) --this.idx;
      if (this.streams.length === 0) this._end();
    }
  }, {
    key: "close",
    value: function close() {
      _get(_getPrototypeOf(MergeIterator.prototype), "close", this).call(this);

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.streams[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var stream = _step2.value;
          stream.close();
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }, {
    key: "read",
    value: function read() {
      for (var attempts = 0; attempts < this.streams.length; ++attempts) {
        this.idx = (this.idx + 1) % this.streams.length;
        var item = this.streams[this.idx].read();
        if (item !== null) return item;
      }

      return null;
    }
  }]);

  return MergeIterator;
}(AsyncIterator);

module.exports = MergeIterator;